export const Footer = () => {
  return (
    <footer className="bg-gray-400 text-white text-center text-base py-14">
      ezBracket © - Alguns direitos reservados
    </footer>
  );
};
